import { OOApi } from './oo-types'

export const getFullUrl = (name: string) => {
    const location = window.location
    const start = location.pathname.lastIndexOf("/") + 1
    const file = location.pathname.slice(start)
    const ret = location.href.replace(file, name)
    return ret
}

const capture = <T>(fun: (Api: OOApi) => T, value: any, options: {
    replacer?: string
    noBrackets?: boolean
} = {}) => {
    const replacer = options.replacer ?? `'{{REPLACE}}'`
    const replaceTo = typeof value == 'object' ? JSON.stringify(value) : value
    const wrappedReplace = options.noBrackets ? replaceTo : `(${replaceTo})`
    const f = fun.toString().replace(replacer, wrappedReplace)
    return new Function(`return ${f}`)()
}

export const callCommand = async <T, S>(params: {
    context: any
    close?: boolean 
    recalc?: boolean
} & ({} | {
    window: any
    params: S
}), f: (Api: OOApi, Asc: {scope: S}) => T): Promise<T> => {
    const inner = () => {
        try {
            const ret = ('{{REPLACE}}' as unknown as Function)()
            return JSON.stringify({
                success: true,
                value: ret,
            })
        } catch (error) {
            console.error(error)
            return JSON.stringify({
                success: false, 
                error: (error as Error).message,
            })
        }
    }
    return new Promise((resolve, reject) => {
        if ('window' in params && params.window && params.params) {
            params.window.Asc.scope = params.params
        }
        const captured = capture(inner, f.toString().replace(/\((Api(, Asc)?)?\) => /, '() => '))
        params.context.callCommand(captured, params.close ?? false, params.recalc ?? false, (ret) => {
            const parsed = JSON.parse(ret)
            if (parsed.success)
                return resolve(parsed.value)
            return reject(new Error(parsed.error))
        })
    })
}

export const executeMethod = async (window, method: string, params: any) => {
    return new Promise((resolve, reject) => {
        try {
            window.Asc.plugin.executeMethod(method, params, (ret) => {
                resolve(ret)
            })
        } catch (err) {
            reject(err)
        }
    })
}

